import { DecimalPipe } from '@angular/common';
import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[cvInputNumericFormat]'
})
export class InputNumericFormatDirective {
  @Input() returnEmptyString: boolean;
    
  constructor(private ngControl: NgControl, private el: ElementRef, private decimalPipe: DecimalPipe) { }

  /**
   * format the formcontrol and input value to allow only numbers
   * @param event get the input event
   */
  @HostListener('input', ['$event']) formatInputNumber(event: Event): void {
    const input = event.target as HTMLInputElement;
    const value = input.value.replace(/,/g, '');
    const formattedValue = this.decimalPipe.transform(parseFloat(value), undefined, CVCultureName);
    this.ngControl.control.setValue(formattedValue ? formattedValue : (this.returnEmptyString ? '' : formattedValue));
    input.value = formattedValue;
  }

}
